module.exports = __webpack_public_path__ + "static/img/pic-6.0fc1ebf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about/pic-6.jpg
// module id = bByO
// module chunks = 1